import { purchaseHistoryService } from '../../../services'

export default (amlOrder) => {
	return new Promise(async (resolve, reject) => {
		await purchaseHistoryService.purchaseDetails(amlOrder)
			.then(response => resolve(response))
			.catch(err => reject({error: true}))
	})
}
